<template>
  <v-card-actions
    class="flex-grow-0 mt-auto"
    :class="{ 'd-block': isMobile }"
  >
    <booking-form-price
      v-if="!isSeasonBooking"
      :selected-rebooking-option="selectedRebookingOption"
      :is-existing-booking="isActiveBookingExisting"
      :loading="isFetchingPricing"
      :charge-total="chargeTotal"
      :rebooking-preview="rebookingPreview"
      :is-mobile="isMobile"
      :has-error="hasRebookingPreviewError"
      @select-rebooking-option="selectRebookingOption"
    ></booking-form-price>
    <v-spacer></v-spacer>
    <v-btn
      v-if="showDropInCheckinButton"
      text
      color="success"
      :large="isMobile"
      :loading="isSavingCheckinAction"
      :disabled="isSaveAndCheckinDisabled"
      @click="saveAndCheckin"
    >
      Spara och checka in
    </v-btn>
    <v-btn
      color="success"
      class="ma-0 mt-4 ma-lg-2"
      :block="isMobile"
      :large="isMobile"
      :loading="isSavingOtherAction"
      :disabled="isSaveDisabled"
      @click="save"
    >
      {{ saveBookingButtonText }}
    </v-btn>
  </v-card-actions>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import BookingFormPrice from '@/components/booking/BookingFormPrice.vue'

export default {
  name: 'BookingFormActionsSection',
  components: {
    BookingFormPrice
  },
  props: {
    hasPositionError: Boolean
  },
  computed: {
    ...mapState('bookingForm', [
      'hasRebookingPreviewError',
      'isFetchingCharges',
      'isFetchingRebookingPreview',
      'isSaving',
      'rebookingPreview',
      'selectedRebookingOption',
      'shouldCheckinAfterSave'
    ]),
    ...mapGetters('bookingForm', [
      'chargeTotal',
      'isActiveBookingExisting',
      'isBookingGroup',
      'isDropInBooking',
      'isSeasonBooking',
      'saveBookingButtonText'
    ]),
    isMobile: function () {
      return this.$vuetify.breakpoint.mdAndDown
    },
    isFetchingPricing: function () {
      return this.isFetchingCharges || this.isFetchingRebookingPreview
    },
    showDropInCheckinButton: function () {
      return this.isDropInBooking && !this.isMobile
    },
    isSavingOtherAction: function () {
      return this.isSaving && !this.shouldCheckinAfterSave
    },
    isSavingCheckinAction: function () {
      return this.isSaving && this.shouldCheckinAfterSave
    },
    isSaveAndCheckinDisabled: function () {
      return this.hasPositionError || this.isFetchingPricing || this.isSavingOtherAction || this.isBookingGroup
    },
    isSaveDisabled: function () {
      return this.hasPositionError || this.isFetchingPricing || this.isSavingCheckinAction
    }
  },
  methods: {
    ...mapActions('bookingForm', [
      'saveForm',
      'setSelectedRebookingOption'
    ]),
    selectRebookingOption: function (option) {
      return this.setSelectedRebookingOption(option)
    },
    saveAndCheckin: function () {
      return this.saveForm({ withCheckin: true })
    },
    save: function () {
      return this.saveForm({ withCheckin: false })
    }
  }
}
</script>
